<template>
	<!-- Shipping -->
	<!-- pc-shipping pc-box box -->
	<div class="">
		<!-- <div class="box__title">
			<i class="material-icons box__icon icon">local_shipping</i>Shipping
		</div> -->
		<div class="box__content">
			<!-- <div class="alert alert-warning d-flex align-items-center">
				<span class="material-icons mr-1">info</span>
				<span>Berat akan di aplikasikan ke semua produk terpilih dan variasinya.</span>
			</div>
			<div class="form-group">
				<label><b class="">Weight (gr)</b></label>
				<input
					type="number"
					class="form-control input"
					:class="{ 'error': isFieldError('product', 'weight') }"
					v-model="weight"
					@change="onWeightChange">
			</div> -->
			<div class="form-group">
				<label>
					<input type="checkbox" class="input-checkbox input-checkbox-large" v-model="shipping.enabled">
					<span></span>
					<span class="input-checkbox-text">Do you want to add shipping cost calculation?</span>
				</label>
			</div>
			<div v-if="shipping.enabled">
				<!-- Shipping Type -->
				<div class="form-group">
					<label><b>Shipping Type</b></label>
					<div class="btn-group btn-group-toggle btn-group-block" role="group">
						<button type="button" class="btn btn-default col" :class="{ 'active': isShippingAutomated }" @click="changeShippingType('automated')">Automated</button>
						<button type="button" class="btn btn-default col" :class="{ 'active': isShippingFlat }" @click="changeShippingType('flat')">Flat</button>
						<button type="button" class="btn btn-default col" :class="{ 'active': isShippingFree }" @click="changeShippingType('free')">Free</button>
					</div>
				</div>

				<!-- Automated -->
				<template v-if="isShippingAutomated">
					<!-- Couriers -->
					<div class="form-group">
						<div class="shipping-couriers">
							<div class="row">
								<template v-for="(courier, index) in shippingCouriers">
									<div class="col-6 col-md-4" :key="index">
										<label>
											<input type="checkbox" class="input-checkbox" :value="courier.key" v-model="shipping.couriers">
											<span></span>
											<span class="input-checkbox-text shipping-logo" :style="{ backgroundImage: `url('/images/logo-${courier.key}.png')`}" :title="courier.label">
											</span>
										</label>
									</div>
								</template>
							</div>
						</div>
					</div>

					<!-- Shipping Services -->
					<div class="shipping-services form-group">
						<label><b>{{ $t('Shipping Services') }}:</b></label>
						<div class="container-fluid">
							<div class="row">
								<div
									class="col-lg-4 p-0"
									v-for="(service, index) in shippingServices"
									:key="index">
									<div class="form-group mb-1">
										<label>
											<input
												type="checkbox"
												class="input-checkbox input-checkbox-large"
												:value="service.value"
												v-model="shipping.services"
												:disabled="shipping.services.length === 1 && shipping.services.indexOf(service.value) !== -1"
											/>
											<span></span>
											<span class="input-checkbox-text">
												<span>{{ service.label }}</span>
												<i
													class="material-icons info"
													v-tooltip="service.info"
													v-if="service.info">
													info
												</i>
											</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Shipping Origin -->
					<div class="shipping-origin mb-3">
						<p><b>{{ $t('Ship From') }}:</b></p>
						<div class="row">
							<div class="col-md-12">
								<!-- Province -->
								<div class="form-group ship-from-field">
									<label>{{ $t('Province') }}</label>
									<multiselect
										placeholder="Select Province"
										label="province_name"
										track-by="province_id"
										v-model="shipping.province"
										:options="provinces"
										:show-labels="false"
										:allow-empty="false"
										:loading="isFetchingProvince"
										:disabled="provinces.length === 0"
										@select="onProvinceChange">
									</multiselect>
								</div>
							</div>
							<div class="col-md-6">
								<!-- City -->
								<div class="form-group ship-from-field">
									<label>{{ $t('City') }}</label>
									<multiselect
										placeholder="Select City"
										label="city_name_with_type"
										track-by="city_id"
										v-model="shipping.city"
										:options="cities"
										:show-labels="false"
										:allow-empty="false"
										:loading="isFetchingCity"
										:disabled="cities.length === 0"
										@select="onCityChange">
									</multiselect>
								</div>
							</div>
							<div class="col-md-6">
								<!-- Subdistrict -->
								<div class="form-group ship-from-field">
									<label>{{ $t('Subdistrict') }}</label>
									<multiselect
										placeholder="Select Subdistrict"
										label="subdistrict_name"
										track-by="_id"
										v-model="shipping.subdistrict"
										:options="subdistricts"
										:show-labels="false"
										:allow-empty="false"
										:loading="isFetchingSubdistrict"
										:disabled="subdistricts.length === 0">
									</multiselect>
								</div>
							</div>
						</div>
					</div>

					<!-- Additional Cost -->
					<div class="form-group m-0">
						<label><b>Additional Shipping Cost</b></label>
						<!-- <input type="number" class="input form-control" v-model.trim="shipping.markup" @change="onShippingMarkupChange"> -->
						<price-input
							class="input form-control"
							:max="1000000"
							v-model="shipping.markup">
						</price-input>
						<div class="pc-input-desc">Add or reduce shipping cost here. (insert negative value to reduce shipping cost)</div>
					</div>
				</template>

				<!-- Flat -->
				<template v-if="isShippingFlat">
					<div class="form-group">
						<label>Flat Shipping Price</label>
						<input type="text" class="input form-control" v-model.trim="shipping.flatPrice" @change="onShippingFlatChange">
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PriceInput from '@/components/PriceInput.vue';
import {
	duplicateVar,
	// getAxiosErrorMessage,
} from '@/lib/helper';
import {
	shippingCouriers,
	shippingServices,
	defaultShipping,
	codCouriers,
} from '@/lib/statics';

export default {
	components: {
		PriceInput,
	},
	data: () => ({
		weight: 1000,
		shippingEnabled: false,
		shippingFlatPrice: 0,
		shippingCouriers: duplicateVar(shippingCouriers),
		shippingServices,
		shipping: duplicateVar(defaultShipping),
		// shippingSmartMode: false,
		codCourier: duplicateVar(codCouriers[0]),
		codShippingCouriers: ['sap'],
	}),
	computed: {
		...mapGetters({
			user: 'user',
			isUserCan: 'isUserCan',
			isTester: 'isTester',
			isAdmin: 'isAdmin',
			defaultShipping: 'defaultShipping',
			provinces: 'productCreator/provinces',
			cities: 'productCreator/cities',
			subdistricts: 'productCreator/subdistricts',
			isFetchingProvince: 'productCreator/isFetchingProvince',
			isFetchingCity: 'productCreator/isFetchingCity',
			isFetchingSubdistrict: 'productCreator/isFetchingSubdistrict',
			isFieldError: 'productCreator/isFieldError',
		}),
		isShippingAutomated() {
			return this.shipping.flat === false && this.shipping.free === false;
		},
		isShippingFlat() {
			return this.shipping.flat === true && this.shipping.free === false;
		},
		isShippingFree() {
			return this.shipping.flat === false && this.shipping.free === true;
		},
		isCreateProduct() {
			// return this.entity === 'product' && this.action === 'create';
			return true;
		},
		isEditProduct() {
			// return this.entity === 'product' && this.action === 'edit';
			return true;
		},
		params() {
			const flatPrice = parseInt(this.shipping.flatPrice);
			const markup = parseInt(this.shipping.markup);
			const couriers = this.shipping.couriers.slice();
			const services = this.shipping.services.slice();
			const provinceId = this.shipping.province
				? this.shipping.province.province_id
				: 0;
			const cityId = this.shipping.city ? this.shipping.city.city_id : 0;
			const subdistrictId = this.shipping.subdistrict
				? this.shipping.subdistrict.subdistrict_id
				: 0;
			// const type = this.shipping.city ? 'city' : '';
			// const name = this.shipping.city ? this.shipping.city.city_name_with_type : '';
			const type = this.shipping.subdistrict ? 'subdistrict' : '';
			const cityName = this.shipping.city
				? this.shipping.city.city_name_with_type
				: '';
			const subdistrictName = this.shipping.subdistrict
				? this.shipping.subdistrict.subdistrict_name
				: '';
			// const isSmart = this.shippingSmartMode;
			// let mode = 'normal';
			// if (isSmart) {
			// 	mode = 'smart';
			// }
			const shipping = {
				enabled: this.shipping.enabled,
				free_shipping: this.shipping.free,
				flat_shipping: this.shipping.flat,
				flat_price: flatPrice,
				origin: {
					// id: cityId,
					id: subdistrictId,
					type,
					name: subdistrictName,
					province_id: provinceId,
					city_id: cityId,
					city_name: cityName,
					subdistrict_id: subdistrictId,
					subdistrict_name: subdistrictName,
				},
				couriers,
				services,
				markup,
				// cod: this.codCourier,
				// cod_couriers: this.codShippingCouriers,
				// mode,
			};

			const params = {
				shipping,
				// weight: this.weight,
			};

			return params;
		},
	},
	watch: {
		user() {
			if (this.isAdmin) {
				document.body.classList.add('is-grey');
			}
			this.checkCapabilities();
			// this.setDefaultShipping();
			// Fetch Provinces
			if (this.provinces.length === 0) {
				console.log('this.provinces: ', this.provinces);
				this.$store.dispatch('productCreator/fetchProvinces');
			}
		},
		provinces() {
			if (this.shipping.province === null) {
				this.setShippingOriginProvince();
			} else {
				this.setDefaultShipping();
			}
		},
		cities() {
			if (this.cities.length === 0) {
				return;
			}
			// if (this.productData) {
			if (this.shipping.city === null) {
				// const isFromCity = this.productData.shipping.origin.type === 'city';
				// const cityId = isFromCity
				// 	? this.productData.shipping.origin.id
				// 	: this.productData.shipping.origin.city_id;
				const cityId = this.user && this.user.store && this.user.store.shipping && this.user.store.shipping.origin && this.user.store.shipping.origin.city && this.user.store.shipping.origin.city.id
					? this.user.store.shipping.origin.city.id
					: 0;
				// eslint-disable-next-line
				const city = this.cities.find(city => city.city_id == cityId);
				if (city) {
					this.shipping.city = city;
					this.fetchSubdistricts(cityId);
				}
			} else if (this.defaultShipping) {
				const cityId = this.defaultShipping.origin.city.id;
				// eslint-disable-next-line
				const city = this.cities.find(city => city.city_id == cityId);
				if (city) {
					this.shipping.city = city;
					this.fetchSubdistricts(cityId);
				}
			}
		},
		subdistricts() {
			if (this.subdistricts.length === 0) {
				return;
			}
			if (this.shipping.subdistrict === null) {
			// if (this.productData) {
				// const subdistrictId = this.productData.shipping.origin.subdistrict_id;
				const subdistrictId = this.user && this.user.store && this.user.store.shipping && this.user.store.shipping.origin && this.user.store.shipping.origin.subdistrict && this.user.store.shipping.origin.subdistrict.id
					? this.user.store.shipping.origin.subdistrict.id
					: 0;
				if (subdistrictId) {
					// eslint-disable-next-line
					const subdistrict = this.subdistricts.find(
						subdistrict => subdistrict.subdistrict_id === subdistrictId,
					);
					if (subdistrict) {
						this.shipping.subdistrict = subdistrict;
					}
				}
			} else if (this.defaultShipping) {
				const subdistrictId = this.defaultShipping.origin.subdistrict
					&& this.defaultShipping.origin.subdistrict.id;
				if (subdistrictId) {
					// eslint-disable-next-line
					const subdistrict = this.subdistricts.find(
						subdistrict => subdistrict.subdistrict_id === subdistrictId,
					);
					if (subdistrict) {
						this.shipping.subdistrict = subdistrict;
					}
				}
			}
		},
		shipping: {
			handler() {
				this.onValueChanged();
			},
			deep: true,
		},
	},
	mounted() {
		// fetch provinces
		if (this.provinces.length === 0) {
			this.fetchProvinces();
		}

		// set default valud origin province
		if (!this.isFetchingProvince && this.shipping.province === null) {
			this.setShippingOriginProvince();
		}
	},
	methods: {
		...mapActions({
			fetchProvinces: 'productCreator/fetchProvinces',
			fetchCities: 'productCreator/fetchCities',
			fetchSubdistricts: 'productCreator/fetchSubdistricts',
			clearCities: 'productCreator/clearCities',
			clearSubdistricts: 'productCreator/clearSubdistricts',
		}),
		checkCapabilities() {
			const cantCreateProduct = this.isCreateProduct && !this.isUserCan('product_add');
			const cantEditProduct =	this.isEditProduct && !this.isUserCan('product_edit');
			if (cantCreateProduct || cantEditProduct) {
				this.$router.push('/');
			} else {
				this.isRouteChecked = true;
			}
		},
		onWeightChange(event) {
			const weight = event.target.value;
			if (weight.trim() === '') {
				this.weight = 0;
			} else {
				this.weight = parseInt(weight);
			}

			this.onValueChanged();
		},
		onShippingFlatChange(event) {
			const defaultValue = event.target.value;
			if (defaultValue.trim() === '') {
				this.shipping.flatPrice = 0;
			}
		},
		onProvinceChange(province) {
			this.shipping.province = province;
			this.shipping.city = null;
			this.shipping.subdistrict = null;
			this.clearCities();
			this.clearSubdistricts();
			const provinceId = province.province_id;
			this.fetchCities(provinceId);
		},
		onCityChange(city) {
			this.shipping.city = city;
			this.shipping.subdistrict = null;
			this.clearSubdistricts();
			const cityId = city.city_id;
			this.fetchSubdistricts(cityId);
		},
		changeShippingType(type = 'automated') {
			if (type === 'automated') {
				this.shipping.flat = false;
				this.shipping.free = false;
			} else if (type === 'flat') {
				this.shipping.flat = true;
				this.shipping.free = false;
			} else if (type === 'free') {
				this.shipping.flat = false;
				this.shipping.free = true;
			}
		},
		setDefaultShipping() {
			this.shipping.couriers = this.defaultShipping.couriers.slice();
			// Set Province
			if (this.provinces.length > 0) {
				const provinceId = this.defaultShipping.origin.province.id;
				this.shipping.province = this.provinces.find(
					province => province.province_id === provinceId,
				);
				this.fetchCities(provinceId);
			}
		},
		setShippingOriginProvince() {
			const provinceId = this.user && this.user.store && this.user.store.shipping && this.user.store.shipping.origin && this.user.store.shipping.origin.province && this.user.store.shipping.origin.province.id
				? this.user.store.shipping.origin.province.id
				: 0;
			// eslint-disable-next-line
			const province = this.provinces.find(
				province => province.province_id === provinceId,
			);
			if (province) {
				this.shipping.province = province;
				this.fetchCities(provinceId);
			}
		},
		onValueChanged() {
			this.$emit('change', this.params);
		},
	},
};
</script>

<style>

</style>
